import { render, staticRenderFns } from "./AddContactRelationships.vue?vue&type=template&id=2dd06b4c&scoped=true&lang=pug"
import script from "./AddContactRelationships.vue?vue&type=script&lang=js"
export * from "./AddContactRelationships.vue?vue&type=script&lang=js"
import style0 from "./AddContactRelationships.vue?vue&type=style&index=0&id=2dd06b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd06b4c",
  null
  
)

export default component.exports